import type { Notification } from '@repo/types/types/notification'
import { AlertTitle, AlertDescription } from '@repo/ui/components/ui/alert'
import { Button } from '@repo/ui/components/ui/button'
import { Check } from 'lucide-react'
import { useNotificationCore } from '@/hooks/useNotificationCore'

interface NotificationFullProps {
  notification: Notification
  onMarkAsRead?: (id: string) => void
  showMarkAsRead?: boolean
}

export function NotificationFull({
  notification,
  onMarkAsRead,
  showMarkAsRead = true
}: NotificationFullProps) {
  const { isUnread, formattedTimestamp, handleMarkAsRead } = useNotificationCore(notification, onMarkAsRead)

  return (
    <>
      <AlertTitle className="flex items-center justify-between">
        <span>{notification.title}</span>
        {showMarkAsRead && isUnread && (
          <Button
            onClick={handleMarkAsRead}
            variant="ghost"
            size="sm"
            className="h-auto cursor-pointer p-1"
          >
            <Check className="h-4 w-4" />
          </Button>
        )}
      </AlertTitle>
      <AlertDescription className="mt-2">
        <p>{notification.message}</p>
        <p className="text-xs text-muted-foreground mt-2">
          {formattedTimestamp}
        </p>
      </AlertDescription>
    </>
  )
}
